<template>
  <div class="app-change-payment-wrapper">
    <slot name="txtBeforeChangePayment"></slot>
    <ChangePaymentViewWrapper v-if="showView" nextStep=changeStepName>
      <template v-for="slot in possibleChildSlotsFor('PaymentView')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ChangePaymentViewWrapper>
    <ChangePaymentChangeWrapper
      v-if="showChange"
      nextStep=successStepName
      :no-payment-possible="false"
      :credit-card-frame-address="creditCardFrameAddress"
      :credit-card-redirect-url="creditCardRedirectUrl"
    >
      <template v-for="slot in possibleChildSlotsFor('ChangePayment')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ChangePaymentChangeWrapper>
    <Success
      v-if="showSuccess"
      nextStep=viewStepName
      :back="backToView"
    >
      <template #txtBefore><slot name="txtSuccessBefore"></slot></template>
      <template #btnSuccessBack><slot name="btnSuccessBack"></slot></template>
      <template #txtAfter><slot name="txtSuccessAfter"></slot></template>
    </Success>
  </div>
</template>
<script>
import ChangePaymentViewWrapper, { stepName as viewStepName } from '../ViewWrapper.vue'
import ChangePaymentChangeWrapper, { stepName as changeStepName } from '../ChangeWrapper.vue'
import Success, { stepName as successStepName } from '../../../../../generic/Success2.vue'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
import slotProxy from '../../../../../../mixins/slotProxy'

export default {
  name: 'ChangePaymentWrapper',
  components: { Success, ChangePaymentChangeWrapper, ChangePaymentViewWrapper },
  mixins: [
    transaction('changePayment'),
    slotProxy()
  ],
  methods: {
    ...mapMutations('changePayment', [
      'changeStep'
    ]),
    backToView () {
      this.changeStep({ step: viewStepName })
    }
  },
  computed: {
    ...mapGetters('changePayment', [
      'currentStep'
    ]),
    showView () {
      return this.currentStep === viewStepName
    },
    showChange () {
      return this.currentStep === changeStepName
    },
    showSuccess () {
      return this.currentStep === successStepName
    }
  },
  props: {
    creditCardFrameAddress: {
      type: String,
      required: true
    },
    creditCardRedirectUrl: {
      type: String
    }
  }
}
</script>
